import React, { useMemo } from 'react';
import ProductBlock from '../../Blocks/ProductBlock';
import { translate } from '../../Services/translation';
import { ProductRelation } from '../../Types/ProductPageModel';

interface productRelationsProps {
  productRelations?: (ProductRelation | undefined)[];
}
const ProductRelationBlockContainer = ({
  productRelations,
}: productRelationsProps) => {
  const filteredProductRelations = useMemo(
    () =>
      productRelations &&
      (productRelations.filter(
        (productRelation) =>
          productRelation && productRelation.value.length > 0
      ) as ProductRelation[]),
    [productRelations]
  );

  return (
    <>
      {filteredProductRelations!.length > 0 &&
        filteredProductRelations?.map((productRelation, idx) => (
          <div
            key={productRelation.key.id + idx}
            className="pb-6 lg:pb-10"
          >
            <ProductBlock
              products={productRelation.value}
              title={translate(
                productRelation.key.id.toLowerCase() + '.title'
              )}
              numPerRow={4}
              showSlider={productRelation.value.length > 2 ? true : false}
              showInfo={true}
              showPatternImage={productRelation.key.id === 'Matching'}
            />
          </div>
        ))}
    </>
  );
};

export default ProductRelationBlockContainer;
